import type { CommissionTotals } from '../../services/resellers.service';
import { formatCurrency } from '../../utils/helpers';

// One commission total. Currencies are never added together: with more than one,
// each gets its own line with its code.
export const CommissionAmount = ({
  totals,
  field,
}: {
  totals?: CommissionTotals;
  field: 'earned' | 'pending' | 'paid';
}) => {
  const rows = totals?.byCurrency ?? [];
  if (!rows.length) return <span>—</span>;
  return (
    <span className="space-y-1">
      {rows.map((row) => (
        <span key={row.currency} className="block">
          {formatCurrency(Number(row[field]), row.currency)}
          {rows.length > 1 && (
            <span className="text-xs font-normal text-(--color-muted-gray)"> {row.currency.toUpperCase()}</span>
          )}
        </span>
      ))}
    </span>
  );
};
